import { Check } from "lucide-react";
import { ETAPAS } from "@/lib/api";

const FLOW = ETAPAS.filter((e) => !["baja", "anulada"].includes(e.id));

export const StageStepper = ({ etapa }) => {
  const idx = FLOW.findIndex((e) => e.id === etapa);
  return (
    <div data-testid="stage-stepper" className="flex items-center gap-1 overflow-x-auto py-1">
      {FLOW.map((e, i) => {
        const done = !["baja", "anulada"].includes(etapa) && i < idx;
        const cur = i === idx;
        return (
          <div key={e.id} className="flex items-center gap-1">
            <div className={`flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium whitespace-nowrap border transition-colors ${cur ? "bg-[#1E3A8A] text-white border-[#1E3A8A]" : done ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-white text-slate-400 border-slate-200"}`}>
              {done ? <Check className="h-3 w-3" /> : <span className="font-[JetBrains_Mono]">{i + 1}</span>}
              {e.label}
            </div>
            {i < FLOW.length - 1 && <div className={`w-4 h-px ${done ? "bg-emerald-300" : "bg-slate-200"}`} />}
          </div>
        );
      })}
      {etapa === "baja" && <span className="ml-2 rounded-full px-3 py-1 text-xs font-medium bg-rose-50 text-rose-700 border border-rose-200">Baja</span>}
      {etapa === "anulada" && <span className="ml-2 rounded-full px-3 py-1 text-xs font-medium bg-orange-50 text-orange-700 border border-orange-200">Cita anulada</span>}
    </div>
  );
};
